import React, { useState } from "react";

import {
	Container,
	Title,
	TabList,
	TabItem,
	ReportContainer,
	Left,
	Right,
	DownloadReportContainer,
	Report,
	ReportTitle,
	ReportDescription,
	Subtitle,
	Compensation,
	CompensationItem,
	SectionContainer,
	Image,
	DownloadReportTitle,
	InputContainer,
	DownloadButtonContainer,
	SelectTabList,
} from "./styles";
import { CloudinaryImage, Select } from "@website-builder/ui/shared/elements";
import Button from "../../Elements/Button";
import Input from "../../Elements/Input";
import axios from "axios";

const OutcomesReport = (props) => {
	const {
		title,
		report_card,
		report_bg_color,
		report_font_color,
		darkBg,
		apiBaseUrl,
	} = props;
	const [currentReport, setCurrentReport] = useState(report_card[0]);
	const [currentReportIndex, setCurrentReportIndex] = useState(0);
	const [email, setEmail] = useState(null);
	const [reportSuccess, setReportSuccess] = useState(null);
	const handleSubmit = (e) => {
		e.preventDefault();
		//Make form data
		var bodyFormData = new FormData();
		bodyFormData.append("email", email);
		bodyFormData.append("lead_type", "OU");
		bodyFormData.append("workshop_id", currentReport.workshop_id);

		const baseUrl =
			apiBaseUrl || `${window.location.protocol}//${window.location.host}`;

		axios({
			method: "POST",
			url: `${baseUrl}/learning-paths/interested/`,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data", withCredentials: true },
		})
			.then((res) => {
				setReportSuccess(res.data);
			})
			.catch((err) => {
				console.error({ err });
			});
	};

	return (
		<Container>
			<Title>{title}</Title>
			<TabList>
				{report_card.map((c, index) => {
					return (
						<TabItem
							isActive={currentReport?.course_name == c?.course_name}
							onClick={() => {
								setCurrentReport(report_card[index]);
							}}
							key={c.course_name}
						>
							{c.course_name}
						</TabItem>
					);
				})}
			</TabList>

			<SelectTabList>
				<Select
					value={currentReportIndex}
					onChange={(event) => {
						setCurrentReportIndex(parseInt(event?.target?.value));
						setCurrentReport(report_card[event?.target?.value]);
					}}
				>
					{report_card.map((o, index) => (
						<option value={index} key={index}>
							{o?.course_name}
						</option>
					))}
				</Select>
			</SelectTabList>

			<ReportContainer>
				<Left>
					<Report>
						<SectionContainer>
							<ReportTitle>{currentReport.title}</ReportTitle>
							<ReportDescription>{currentReport.description}</ReportDescription>
						</SectionContainer>
						{currentReport?.compensation_label ||
						currentReport.compensation?.length ? (
							<SectionContainer>
								{currentReport?.compensation_label && (
									<Subtitle>{currentReport?.compensation_label}</Subtitle>
								)}

								<Compensation>
									{currentReport.compensation?.map((c) => (
										<CompensationItem key={c?.title}>
											<div className="salary">{c?.title}</div>
											<div className="salary-info">{c?.description}</div>
										</CompensationItem>
									))}
								</Compensation>
							</SectionContainer>
						) : null}
						{currentReport?.image_label || currentReport?.graph?.image ? (
							<SectionContainer>
								{currentReport?.image_label && (
									<Subtitle>{currentReport?.image_label}</Subtitle>
								)}
								<Image>
									<CloudinaryImage
										className="graph"
										url={currentReport?.graph?.image || ""}
										key={currentReport?.graph?.image || ""}
										lazyload
										alt={currentReport?.graph?.alt}
									/>
								</Image>
							</SectionContainer>
						) : null}
					</Report>
				</Left>
				<Right>
					<DownloadReportContainer
						bg={report_bg_color}
						font={report_font_color}
					>
						<div className="column-flex">
							<DownloadReportTitle font={report_font_color}>
								Interested to read more? Get the full report.
							</DownloadReportTitle>
							<Image>
								<CloudinaryImage
									className="downloadReport"
									key={currentReport?.download_report_image?.image || ""}
									url={currentReport?.download_report_image?.image || ""}
									lazyload
									alt=""
								/>
							</Image>
							{reportSuccess ? (
								<div class="success-message">
									The report is on the way to your mailbox!
								</div>
							) : (
								<form onSubmit={handleSubmit}>
									<InputContainer>
										<Input
											value={email}
											onChange={(e) => {
												setEmail(e.target.value);
											}}
											placeholder="Email"
											type="email"
										/>
									</InputContainer>

									<DownloadButtonContainer>
										<Button type="submit" darkBg={darkBg}>
											Download full report
										</Button>
									</DownloadButtonContainer>
								</form>
							)}
						</div>
					</DownloadReportContainer>
				</Right>
			</ReportContainer>
		</Container>
	);
};

export default OutcomesReport;
